// NEW (not in TP, whose job cards only say Running / Done): one status badge for every job card, on TP's `Badge`.
// queued is neutral, running is warning with a pulsing dot (guarded for reduced motion, which TP's is not), done is
// success, partial is warning without the pulse, unavailable is error, and `empty` (the job finished with nothing to
// show) is neutral.
import { Badge } from '@/components/ui/shadcn/badge';
import { cn } from '@/lib/utils';

export type JobBadgeStatus = 'queued' | 'running' | 'done' | 'partial' | 'unavailable' | 'empty';

export const JOB_BADGE: Record<JobBadgeStatus, { label: string; intent: 'neutral' | 'warning' | 'success' | 'error' }> = {
  queued: { label: 'Queued', intent: 'neutral' },
  running: { label: 'Running', intent: 'warning' },
  done: { label: 'Done', intent: 'success' },
  partial: { label: 'Partly done', intent: 'warning' },
  unavailable: { label: "Couldn't read", intent: 'error' },
  empty: { label: 'No matches', intent: 'neutral' },
};

export function JobBadge({ status, className, ...rest }: { status: JobBadgeStatus; className?: string; 'data-testid'?: string }) {
  const badge = JOB_BADGE[status];
  return (
    <Badge
      intent={badge.intent}
      dot
      className={cn('shrink-0', status === 'running' && '[&>span:first-child]:motion-safe:animate-pulse', className)}
      {...rest}
    >
      {badge.label}
    </Badge>
  );
}
